import { useId } from 'react';

/**
 * La explicación de algo, guardada detrás de un icono.
 *
 * Existe para ganar espacio sin perder la explicación. Una pantalla que lo
 * cuenta todo en párrafos se lee una vez y estorba las siguientes; una que no
 * cuenta nada deja a quien llega por primera vez adivinando. La pista resuelve
 * las dos: el número se ve siempre, el porqué aparece cuando se pregunta.
 *
 * **Se abre con el teclado, no sólo con el ratón.** `:focus-visible` cuenta
 * igual que `:hover`, y el texto va enlazado con `aria-describedby`, así que un
 * lector de pantalla lo anuncia sin que nadie tenga que apuntar a nada. Una
 * pista que sólo responde al cursor es una explicación que no existe para quien
 * navega con teclado.
 */
export function Pista({ texto }: { texto: string }) {
  const id = useId();

  return (
    <span className="pista">
      <button
        type="button"
        className="pista__boton"
        aria-describedby={id}
        aria-label={texto}
        // El botón no hace nada al pulsarlo: abrir con hover y foco ya cubre
        // ratón, teclado y táctil —en táctil, el toque da el foco—.
        onClick={(e) => e.currentTarget.focus()}
      >
        <svg viewBox="0 0 16 16" width="13" height="13" aria-hidden="true">
          <circle cx="8" cy="8" r="6.6" fill="none" stroke="currentColor" strokeWidth="1.3" />
          <path
            d="M6.3 6.1c.1-1 .9-1.7 1.8-1.7 1 0 1.7.6 1.7 1.5 0 .8-.4 1.2-1.1 1.7-.6.4-.8.7-.8 1.3v.3"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.3"
            strokeLinecap="round"
          />
          <circle cx="8" cy="11.6" r=".85" fill="currentColor" />
        </svg>
      </button>
      <span className="pista__texto" id={id} role="tooltip">
        {texto}
      </span>
    </span>
  );
}
